import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, LockIcon, CreditCardIcon, ArrowRightIcon } from 'lucide-react';
const badges = [{
  icon: '⚡',
  text: 'Acceso Inmediato'
}, {
  icon: '🇦🇷',
  text: 'Hecho para Argentina'
}, {
  icon: '🔒',
  text: 'Pago Seguro'
}];
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-navy-950 text-white overflow-hidden pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-116" data-mp="xae7j0m5yila">
      <div className="absolute inset-0 z-0 overflow-hidden" aria-hidden="true" data-id="element-117" data-mp="sb1axo5hpx5i">
        <div className="absolute top-[10%] left-1/2 -translate-x-1/2 w-[120%] h-[80%] rounded-full bg-navy-600/40 blur-[120px]" data-id="element-118" data-mp="sd4aaysj92mw"></div>
        <div className="absolute -bottom-1/4 left-1/2 -translate-x-1/2 w-[80%] h-[60%] rounded-full bg-blue-500/10 blur-[100px]" data-id="element-119" data-mp="3d21ty23jwspu"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-120" data-mp="3814cjrqd82pe">
        <div className="max-w-4xl mx-auto text-center" data-id="element-121" data-mp="3j893p1w0vrk9">
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex gap-2 text-silver font-bold tracking-wide items-center justify-center mb-6 font-[Merriweather,_serif]" data-id="element-122" data-mp="3j6oe7qokeyt9">
            🔍 MEGAPACK CRIMINALÍSTICA LISTO™
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-[20px] sm:text-4xl md:text-5xl lg:text-6xl font-black tracking-tight mb-10 text-silver-light text-balance font-[Merriweather,_serif]" data-id="element-123" data-mp="35a2jupnwrs3l">
            Del Principio de Locard al Aula. Todo Resuelto.
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} className="relative max-w-[260px] sm:max-w-[320px] md:max-w-[400px] lg:max-w-lg mx-auto mb-10" data-id="element-124" data-mp="nat8vfsf4smt">
            <img src="https://cdn.magicpatterns.com/uploads/6cdcMZte9HfCu3UGNRXHxv/MOCKUP.png" alt="MEGAPACK CRIMINALÍSTICA LISTO — 6 tomos, 4 bonos y 2 módulos avanzados listos para usar en el aula" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(201,212,228,0.2)]" data-id="element-125" data-mp="162uer23m1j5q" />
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-[14px] md:text-xl font-bold text-silver mb-6 text-balance font-[Merriweather,_serif]" data-id="element-126" data-mp="3lqm2xztl37vg">
            Todo lo que necesitás para enseñar Criminalística de forma clara,
            actualizada y 100% lista para usar en el aula.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-wrap justify-center mb-[30px] gap-[6px]" data-id="element-127" data-mp="2kyvqxrk6mcpj">
            {badges.map(badge => <span key={badge.text} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-navy-800/80 border border-silver/30 font-semibold backdrop-blur-sm text-[12px] text-silver-light" data-id="element-128" data-mp="zndrthx4fm7h">
                <span aria-hidden="true" data-id="element-129" data-mp="e8innsyzktbr">{badge.icon}</span> {badge.text}
              </span>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="mb-10" data-id="element-130" data-mp="9b8m5eybor7k">
            <button onClick={scrollToPricing} className="inline-flex items-center justify-center gap-2 px-10 py-5 rounded-2xl bg-silver hover:bg-silver-light text-navy-950 font-black uppercase tracking-wide shadow-[0_10px_40px_-10px_rgba(201,212,228,0.45)] hover:shadow-[0_15px_50px_-10px_rgba(201,212,228,0.65)] transition-all hover:-translate-y-1 md:text-base text-[12px]" data-id="element-131" data-mp="3mo2cmfsmjpl0">
              🔥 QUIERO MI MEGAPACK AHORA
              <ArrowRightIcon className="w-5 h-5" data-id="element-132" data-mp="zl96ufadmqdn" />
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-silver-dark font-medium" data-id="element-133" data-mp="14isuu6wvmhis">
            <div className="flex items-center gap-1.5" data-id="element-134" data-mp="1nc543rxlqdsa">
              <ShieldIcon className="w-4 h-4 text-silver" data-id="element-135" data-mp="7s8pauilfip1" />
              <span data-id="element-136" data-mp="buwyj3b7yrmj">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-137" data-mp="bwgh50kclerh">
              <LockIcon className="w-4 h-4 text-silver" data-id="element-138" data-mp="2ei3nfz2fpxcf" />
              <span data-id="element-139" data-mp="2egsnkac419ql">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-140" data-mp="29i7ju0xng7xe">
              <CreditCardIcon className="w-4 h-4 text-silver" data-id="element-141" data-mp="29ktptw4w6fdi" />
              <span data-id="element-142" data-mp="24qfz4716cwf6">Mercado Pago</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}